export default {
  title: 'Privacy Policy',
  docTitle: 'BetCorgi Privacy Policy',
  docSubtitle: 'Learn how we protect and use your information',
  intro:
    'We process your information under the principles of necessity, clarity, and security. This policy explains how information is collected, used, stored, and protected.',
  s1Title: 'Information We Collect',
  s1Body:
    'This may include account details, bound phone or email, identity verification data, device and login information, deposit and withdrawal records, receiving accounts, operation logs, and other information necessary to provide the service.',
  s2Title: 'How We Use Information',
  s2Body:
    'Used to create and manage accounts, complete transactions and identity verification, safeguard accounts and funds, identify fraud risks, provide customer support, resolve disputes, improve our products, and fulfill applicable compliance obligations.',
  s3Title: 'Information Sharing',
  s3Body:
    'We share information only to the extent necessary for payment processing, identity verification, technical services, risk control, or lawful regulatory cooperation, with carefully selected partners. We do not sell your personal information.',
  s4Title: 'Storage & Security',
  s4Body:
    'We protect information through access control, transmission encryption, risk monitoring, and data minimization, and retain it only for the period necessary to fulfill its purpose or as required by law; it is then deleted or anonymized.',
  s5Title: 'Your Rights',
  s5Body:
    'You may view and correct certain details in your account or security center, and manage binding methods and authorizations; you may also contact support to request access, correction, deletion, or account cancellation. For security, we may verify your identity first.',
  s6Title: 'Device Information & Local Storage',
  s6Body:
    'To maintain login state, save interface preferences, and improve the experience, cookies or local storage may be used. Some features may not work properly if disabled; you can manage this via your device or browser settings.',
  s7Title: 'Protection of Minors',
  s7Body:
    'The platform provides services only to users aged 18 or above. If you find that a minor\u2019s information has been collected by mistake, please contact us for verification and prompt handling.',
  s8Title: 'Policy Updates & Contact',
  s8Body:
    'Material changes will be announced via prominent notices or in-site messages. If you have questions about personal information processing or wish to exercise your rights, contact online support.',
  done: 'I Have Read',
}
